//libs
import { useCallback, useState } from 'react';

import { PlayCircle2 } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, mergeOverrides } from '@lyearn/ui';

//styles
import { PlayIconStyles } from './styles';
//types
import { VideoProps } from './types';
import { getDefaults } from './utils';

const Video: React.FC<VideoProps> = (props) => {
  const { className, src, name = 'Video', overrides, ...rest } = props;
  const [showPlayIcon, setPlayIcon] = useState(true);

  const hidePlayIcon = useCallback(() => setPlayIcon(false), []);

  const defaults = getDefaults();

  const mergedOverrides = mergeOverrides(defaults, overrides);

  return (
    <Box className={cn('relative h-full w-full', className)} onClick={hidePlayIcon} {...rest}>
      {showPlayIcon ? (
        <PlayCircle2
          className={cn('absolute h-48 w-48 fill-current text-interactive-white', PlayIconStyles)}
          height="48"
          width="48"
        />
      ) : null}
      <video
        className={cn('h-full w-full rounded', className)}
        src={src}
        title={name}
        {...mergedOverrides.Video}
      />
    </Box>
  );
};

export default Video;
